import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TOptions } from 'i18next';

import {
  TranslationKeys,
  getTranslationGroupForInstance,
  resolveWhitelabelTranslationKey,
} from 'localization';

import { useWhitelabel } from 'lane-shared/hooks/useWhitelabel';

type WtOptions = {
  tOptions?: TOptions;
};

export function useWhitelabelTranslation() {
  const { t } = useTranslation();
  const whitelabel = useWhitelabel();
  const translationGroup = useMemo(
    () => getTranslationGroupForInstance(whitelabel.instance),
    [whitelabel.instance]
  );

  const resolveKey = useCallback(
    (baseKey: TranslationKeys): string => {
      return resolveWhitelabelTranslationKey(baseKey, {
        instance: whitelabel.instance,
        translationGroup,
      });
    },
    [whitelabel.instance, translationGroup]
  );

  const wt = useCallback(
    (baseKey: TranslationKeys, options?: WtOptions): string => {
      return t(resolveKey(baseKey), options?.tOptions);
    },
    [t, resolveKey]
  );

  return { wt, resolveKey };
}
